import React from "react";
import { Box, CsiImage } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import styles from "./ExplorationIcon.module.css";

interface ExplorationIconProps {
    thumbnailIcon: string;
}

const ExplorationIcon = ({ thumbnailIcon }: ExplorationIconProps) => (
	<Box
		alignItems="center"
		bgcolor={grey[100]}
		border={STANDARD_BORDER_STYLE}
		borderColor={grey[400]}
		borderRadius={1}
		display="flex"
		height={80}
		justifyContent="center"
		width={80}
	>
		<CsiImage
			aspectRatio={1}
			className={styles.iconFilter}
			height={32}
			src={thumbnailIcon}
			width={32}
		/>
	</Box>
);

export default ExplorationIcon;
